import React, { memo, useState } from 'react';
import { FieldErrors, UseFormMethods } from 'react-hook-form';
import { KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/dayjs';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { stringConstants } from './strings';
import { CustomError } from '../common/customError';
import { Dayjs } from 'dayjs';

interface DatePickerProps  {
    register: UseFormMethods['register'];
    fieldsErrors: FieldErrors;
    setActualDate: (date: string) => void;
}

// Apple demanded that we remove the day part of this.
export const DatePicker = memo(({ 
    register,
    fieldsErrors,
    setActualDate
}: DatePickerProps) => {
    const [selectedDate, changeSelectedDate] = useState<string>('');
    const [isDatePickerOpen, setIsDatePickerOpen] = useState<boolean>(false);
    const [datepickerChanged, setDatepickerChanged] = useState<boolean>(false);
    const { t } = useTranslation();
    const translatedPleaseEnterValidDateErrorMessage = t('pleaseEnterValidDate');

    const changeDates = (date: Dayjs) => {
        changeSelectedDate(date?.format(stringConstants.displayDateFormat));
        setActualDate(date?.format(stringConstants.valueDateFormat));
    };

    return (
        <Grid item xs={12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker 
                    placeholder='Enter birth month and year'
                    views={['year', 'month']}
                    InputProps={{ readOnly: true }}
                    id='dob'
                    name='dob'
                    format={stringConstants.displayDateFormat}
                    inputVariant='outlined'
                    size='small'
                    value={selectedDate ?? ''}
                    inputValue={selectedDate}
                    defaultValue={''}
                    onChange={newDate => {
                        newDate && changeDates(newDate);
                    }}
                    fullWidth
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputRef={register({
                        required: translatedPleaseEnterValidDateErrorMessage
                    })}
                    helperText={''}
                    error={!selectedDate && datepickerChanged}
                    onClick={() => {setIsDatePickerOpen(true); setDatepickerChanged(true);}}
                    open={isDatePickerOpen}
                    onClose={() => setIsDatePickerOpen(false)}
                />
           
            </MuiPickersUtilsProvider>
            {fieldsErrors.dob 
                && datepickerChanged
                && <CustomError>
                    {fieldsErrors.dob.message}
                </CustomError>
            }
        </Grid>
    );
});
